import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.LIGHT2};
  width: 100%;
  left: 0px;
  top: 0px;
  height: 100%;
  display: flex;
  z-index: 3000;
  position: fixed;

  @media (max-width: 1024px) {
  }
`;

export const Header = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }) =>
    `linear-gradient(to bottom,rgba(0,0,0,0.1), rgba(0,0,0,0))`};
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  h1 {
    font-size: 36px;
    color: ${({ theme }) => theme.colors.TEXT1};
  }

  button {
    background: none;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 1024px) {
    padding: 15px;
    padding-bottom: 0px;

    h1 {
      font-size: 2rem;
    }
  }
`;

export const Controls = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 1rem 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: ${({ theme }) => theme.colors.LIGHT2};

  @media (max-width: 1024px) {
  }
`;

export const Control = styled.button.attrs({
  type: 'button',
})`
  float: left;
  cursor: pointer;
  padding: 0 1rem;

  @media (max-width: 1024px) {
  }
`;

export const Content = styled.div`
  width: 100%;
  background: #333;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;

  @media (max-width: 1024px) {
  }
`;

export const Left = styled.div`
  width: 60%;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  @media (max-width: 1024px) {
  }
`;

export const Center = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  padding: 4rem;

  @media (max-width: 1024px) {
  }
`;

export const ImageCrop = styled.img`
  max-height: 60rem;

  @media (max-width: 1024px) {
  }
`;

export const Footer = styled.div`
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 2rem;
  background: ${({ theme }) =>
    `linear-gradient(to top,rgba(0,0,0,0.1), rgba(0,0,0,0))`};

  @media (max-width: 1024px) {
  }
`;

export const Right = styled.div`
  width: 40%;
  background: #333;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 6rem;

  @media (max-width: 1024px) {
  }
`;
export const Preview = styled.div`
  width: auto;
  padding: 2rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    float: left;
    border-radius: 1rem;
  }

  @media (max-width: 1024px) {
    margin: 20px 0 0 0;
  }
`;
